// src/services/financeApi.ts
import apiClient from "./apiClient";

export const getAnnualFinance = (year: string) =>
  apiClient.get(`/finance/annual/${year}`);

export const getFinanceSummary = () => apiClient.get(`/finance/summary`);

export const getFinanceSummaryByYear = (year: string) =>
  apiClient.get(`/finance/summary/${year}`);

export const getAnnualCategoryWiseBestSellers = (year: string) =>
  apiClient.get(`/finance/category-analysis/${year}`);

export const addBusinessExpense = (data: any) =>
  apiClient.put(`/finance/business-expense`, data);

export const deleteBusinessExpense = (year: string, id: string) =>
  apiClient.delete(`/finance/business-expense/${year}/${id}`);

export type ExpenseCategory = {
  _id: string;
  name: string;
  scope?: "expense" | "inventory" | "both";
  createdAt?: string;
  updatedAt?: string;
};

export async function listExpenseCategories(
  scope: "expense" | "inventory" | "both" | "all" = "expense"
): Promise<ExpenseCategory[]> {
  const { data } = await apiClient.get("/finance/expense-categories", {
    params: { scope },
  });
  return Array.isArray(data) ? data : [];
}

export async function createExpenseCategory(
  name: string,
  scope: "expense" | "inventory" | "both" = "expense"
): Promise<ExpenseCategory> {
  const { data } = await apiClient.post("/finance/expense-categories", {
    name,
    scope,
  });
  return data?.category ?? data;
}

export async function deleteExpenseCategory(id: string): Promise<{ ok: true }> {
  const { data } = await apiClient.delete(`/finance/expense-categories/${id}`);
  return data;
}
export const updateBusinessExpense = (
  year: string,
  id: string,
  data: {
    description: string;
    cost: number;
    createdAt?: string;
    date?: string;
    expenseDate?: string;
    category?: string;
  }
) => apiClient.patch(`/finance/business-expense/${year}/${id}`, data);
